import axios from "axios";
import { APIAdapter } from "../../../helpers/api_helper";

const api = new APIAdapter();

  export const getMarchandById = async (merchandId) => {
    try {
      const response = await api.get(`/merchants/${merchandId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

export const getCompanyByMarchandId = async (merchandId) => {
  try {
    const response = await api.get(`/merchants/${merchandId}/companies`);
    return response;
  } catch (error) {
    throw error;
  }
};

  // export const addDocKycMerchandJson = async (data) => {
  //   const params = new URLSearchParams();

  //     if (data?.merchandId) {
  //       params.append("merchantId", data.merchandId);
  //     }

  //     if (data?.merchantDocumentType) {
  //       params.append("merchantDocumentType", data.merchantDocumentType);
  //     }
  //   try {
  //     const response = await api.create(`/kyc/submit?${params.toString()}`, data);
  //     return response;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  export const addDocKycMerchand = async (files) => {
   
    const formData = new FormData();

    if (files.businessId) {
      formData.append("businessId", files.businessId);
    }
    if (files.merchantDocumentType) {
      formData.append("merchantDocumentType", files.merchantDocumentType);
    }
    if (files.merchantRecto) {
      formData.append("merchantRecto", files.merchantRecto);
    }
    if (files.merchantVerso) {
      formData.append("merchantVerso", files.merchantVerso);
    }
    if (files.businessNinea) {
      formData.append("businessNinea", files.businessNinea);
    }
    if (files.businessStatut) {
      formData.append("businessStatut", files.businessStatut);
    }
    if (files.businessRegistre) {
      formData.append("businessRegistre", files.businessRegistre);
    }
    if (files.RIB) {
      formData.append("RIB", files.RIB);
    }
    if (files.Domicile) {
      formData.append("Domicile", files.Domicile);
    }
    try {
      const response = await axios.post(`/kyc/submit?merchantId=${files?.merchandId}`,
        formData,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${files?.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response;
    } catch (error) {
      console.error("Erreur upload :", error);
      throw error;
    }
  };
